import { useState, type ReactNode } from 'react'
import LentalsLogo from '../LentalsLogo'

const STORAGE_KEY = 'siteAccess'
const GRANTED = 'granted'

interface PasswordGateProps {
  children: ReactNode
}

export default function PasswordGate({ children }: PasswordGateProps) {
  const [granted, setGranted] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) === GRANTED
  )
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  if (granted) return <>{children}</>

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (password === import.meta.env.VITE_SITE_PASSWORD) {
      sessionStorage.setItem(STORAGE_KEY, GRANTED)
      setGranted(true)
    } else {
      setError('Incorrect access code')
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#1a2744]">
      <form
        onSubmit={handleSubmit}
        className="mx-4 flex w-full max-w-sm flex-col items-center gap-6 rounded-2xl bg-white/5 p-8 backdrop-blur-sm"
      >
        <LentalsLogo size="lg" dark={false} />

        <p className="text-center text-sm text-white/70">
          This site is currently in private beta
        </p>

        <div className="w-full space-y-3">
          <input
            type="password"
            placeholder="Enter access code"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value)
              if (error) setError('')
            }}
            className="w-full rounded-lg border border-white/10 bg-white/10 px-4 py-2.5 text-sm text-white placeholder-white/40 outline-none focus:border-[#c87941] focus:ring-1 focus:ring-[#c87941]"
            autoFocus
          />
          {error && (
            <p className="text-center text-sm text-red-400">{error}</p>
          )}
        </div>

        <button
          type="submit"
          className="w-full rounded-lg bg-[#c87941] px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#b5693a]"
        >
          Enter
        </button>
      </form>
    </div>
  )
}
